import { useState, useRef, useEffect } from "react";

// Comprehensive list of US states and major cities
const US_LOCATIONS = [
  // States
  { label: "Alabama, United States", type: "state" },
  { label: "Alaska, United States", type: "state" },
  { label: "Arizona, United States", type: "state" },
  { label: "Arkansas, United States", type: "state" },
  { label: "California, United States", type: "state" },
  { label: "Colorado, United States", type: "state" },
  { label: "Connecticut, United States", type: "state" },
  { label: "Delaware, United States", type: "state" },
  { label: "Florida, United States", type: "state" },
  { label: "Georgia, United States", type: "state" },
  { label: "Hawaii, United States", type: "state" },
  { label: "Idaho, United States", type: "state" },
  { label: "Illinois, United States", type: "state" },
  { label: "Indiana, United States", type: "state" },
  { label: "Iowa, United States", type: "state" },
  { label: "Kansas, United States", type: "state" },
  { label: "Kentucky, United States", type: "state" },
  { label: "Louisiana, United States", type: "state" },
  { label: "Maine, United States", type: "state" },
  { label: "Maryland, United States", type: "state" },
  { label: "Massachusetts, United States", type: "state" },
  { label: "Michigan, United States", type: "state" },
  { label: "Minnesota, United States", type: "state" },
  { label: "Mississippi, United States", type: "state" },
  { label: "Missouri, United States", type: "state" },
  { label: "Montana, United States", type: "state" },
  { label: "Nebraska, United States", type: "state" },
  { label: "Nevada, United States", type: "state" },
  { label: "New Hampshire, United States", type: "state" },
  { label: "New Jersey, United States", type: "state" },
  { label: "New Mexico, United States", type: "state" },
  { label: "New York, United States", type: "state" },
  { label: "North Carolina, United States", type: "state" },
  { label: "North Dakota, United States", type: "state" },
  { label: "Ohio, United States", type: "state" },
  { label: "Oklahoma, United States", type: "state" },
  { label: "Oregon, United States", type: "state" },
  { label: "Pennsylvania, United States", type: "state" },
  { label: "Rhode Island, United States", type: "state" },
  { label: "South Carolina, United States", type: "state" },
  { label: "South Dakota, United States", type: "state" },
  { label: "Tennessee, United States", type: "state" },
  { label: "Texas, United States", type: "state" },
  { label: "Utah, United States", type: "state" },
  { label: "Vermont, United States", type: "state" },
  { label: "Virginia, United States", type: "state" },
  { label: "Washington, United States", type: "state" },
  { label: "West Virginia, United States", type: "state" },
  { label: "Wisconsin, United States", type: "state" },
  { label: "Wyoming, United States", type: "state" },
  // Major Cities
  { label: "New York City, New York, United States", type: "city" },
  { label: "Los Angeles, California, United States", type: "city" },
  { label: "Chicago, Illinois, United States", type: "city" },
  { label: "Houston, Texas, United States", type: "city" },
  { label: "Phoenix, Arizona, United States", type: "city" },
  { label: "Philadelphia, Pennsylvania, United States", type: "city" },
  { label: "San Antonio, Texas, United States", type: "city" },
  { label: "San Diego, California, United States", type: "city" },
  { label: "Dallas, Texas, United States", type: "city" },
  { label: "San Jose, California, United States", type: "city" },
  { label: "Austin, Texas, United States", type: "city" },
  { label: "Jacksonville, Florida, United States", type: "city" },
  { label: "Fort Worth, Texas, United States", type: "city" },
  { label: "Columbus, Ohio, United States", type: "city" },
  { label: "Charlotte, North Carolina, United States", type: "city" },
  { label: "San Francisco, California, United States", type: "city" },
  { label: "Indianapolis, Indiana, United States", type: "city" },
  { label: "Seattle, Washington, United States", type: "city" },
  { label: "Denver, Colorado, United States", type: "city" },
  { label: "Washington, D.C., United States", type: "city" },
  { label: "Boston, Massachusetts, United States", type: "city" },
  { label: "El Paso, Texas, United States", type: "city" },
  { label: "Nashville, Tennessee, United States", type: "city" },
  { label: "Detroit, Michigan, United States", type: "city" },
  { label: "Oklahoma City, Oklahoma, United States", type: "city" },
  { label: "Portland, Oregon, United States", type: "city" },
  { label: "Las Vegas, Nevada, United States", type: "city" },
  { label: "Memphis, Tennessee, United States", type: "city" },
  { label: "Louisville, Kentucky, United States", type: "city" },
  { label: "Baltimore, Maryland, United States", type: "city" },
  { label: "Milwaukee, Wisconsin, United States", type: "city" },
  { label: "Albuquerque, New Mexico, United States", type: "city" },
  { label: "Tucson, Arizona, United States", type: "city" },
  { label: "Fresno, California, United States", type: "city" },
  { label: "Sacramento, California, United States", type: "city" },
  { label: "Atlanta, Georgia, United States", type: "city" },
  { label: "Kansas City, Missouri, United States", type: "city" },
  { label: "Miami, Florida, United States", type: "city" },
  { label: "Raleigh, North Carolina, United States", type: "city" },
  { label: "Omaha, Nebraska, United States", type: "city" },
  { label: "Minneapolis, Minnesota, United States", type: "city" },
  { label: "Cleveland, Ohio, United States", type: "city" },
  { label: "Tampa, Florida, United States", type: "city" },
  { label: "Orlando, Florida, United States", type: "city" },
  { label: "Pittsburgh, Pennsylvania, United States", type: "city" },
  { label: "Cincinnati, Ohio, United States", type: "city" },
  { label: "St. Louis, Missouri, United States", type: "city" },
  { label: "Salt Lake City, Utah, United States", type: "city" },
  // International locations
  { label: "Toronto, Canada", type: "international" },
  { label: "Vancouver, Canada", type: "international" },
  { label: "Montreal, Canada", type: "international" },
  { label: "London, United Kingdom", type: "international" },
  { label: "Manchester, United Kingdom", type: "international" },
  { label: "Sydney, Australia", type: "international" },
  { label: "Melbourne, Australia", type: "international" },
  { label: "Berlin, Germany", type: "international" },
  { label: "Munich, Germany", type: "international" },
  { label: "Paris, France", type: "international" },
  { label: "Amsterdam, Netherlands", type: "international" },
  { label: "Dublin, Ireland", type: "international" },
  { label: "Singapore", type: "international" },
  { label: "Hong Kong", type: "international" },
  { label: "Tokyo, Japan", type: "international" },
  { label: "Mumbai, India", type: "international" },
  { label: "Bangalore, India", type: "international" },
  { label: "Dubai, United Arab Emirates", type: "international" },
  { label: "Tel Aviv, Israel", type: "international" },
  { label: "Stockholm, Sweden", type: "international" },
];

export default function LocationAutocomplete({ 
  value, 
  onChange, 
  placeholder, 
  label,
  helperText,
  testId 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Filter suggestions based on input
  useEffect(() => {
    if (value && value.length >= 2) {
      const filtered = US_LOCATIONS.filter(loc => 
        loc.label.toLowerCase().includes(value.toLowerCase())
      ).slice(0, 8); // Limit to 8 suggestions
      setSuggestions(filtered);
      setIsOpen(filtered.length > 0);
    } else {
      setSuggestions([]);
      setIsOpen(false);
    }
    setHighlightedIndex(-1);
  }, [value]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current && 
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (location) => {
    onChange(location.label);
    setIsOpen(false);
    inputRef.current?.blur();
  };

  const handleKeyDown = (e) => {
    if (!isOpen) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightedIndex(prev => 
          prev < suggestions.length - 1 ? prev + 1 : prev
        );
        break;
      case "ArrowUp":
        e.preventDefault();
        setHighlightedIndex(prev => prev > 0 ? prev - 1 : -1);
        break;
      case "Enter":
        e.preventDefault();
        if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
          handleSelect(suggestions[highlightedIndex]);
        }
        break;
      case "Escape":
        setIsOpen(false);
        break;
      default:
        break;
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case "state": return "🏛️";
      case "city": return "🏙️";
      case "international": return "🌍";
      default: return "📍";
    }
  };

  return (
    <div className="form-group" style={{ position: "relative" }}>
      {label && <label className="form-label">{label}</label>}
      <input
        ref={inputRef}
        type="text"
        className="form-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => value?.length >= 2 && suggestions.length > 0 && setIsOpen(true)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        data-testid={testId}
        autoComplete="off"
      />
      {helperText && (
        <p style={{ fontSize: "11px", color: "#64748b", marginTop: "4px" }}>
          {helperText}
        </p>
      )}
      
      {/* Dropdown */}
      {isOpen && suggestions.length > 0 && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 50,
            marginTop: "4px",
            background: "white",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
            maxHeight: "280px",
            overflowY: "auto"
          }}
        >
          {suggestions.map((suggestion, index) => (
            <div
              key={suggestion.label}
              onClick={() => handleSelect(suggestion)}
              onMouseEnter={() => setHighlightedIndex(index)}
              style={{
                padding: "10px 14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                background: highlightedIndex === index ? "#f1f5f9" : "white",
                borderBottom: index < suggestions.length - 1 ? "1px solid #f1f5f9" : "none",
                transition: "background 0.15s"
              }}
            >
              <span style={{ fontSize: "16px" }}>{getTypeIcon(suggestion.type)}</span>
              <div style={{ flex: 1 }}>
                <div style={{ 
                  fontSize: "13px", 
                  fontWeight: "500", 
                  color: "#1e293b" 
                }}>
                  {suggestion.label}
                </div>
                <div style={{ 
                  fontSize: "11px", 
                  color: "#94a3b8",
                  textTransform: "capitalize"
                }}>
                  {suggestion.type === "state" ? "State" : 
                   suggestion.type === "city" ? "City" : 
                   "International"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
